import moment from 'moment';
import getInitialState from './state';

const mutations = {
  doneStep(state, value) {
    state.done[value] = true;
  },
  unDoneStep(state, value) {
    Object.keys(state.done).forEach((step) => {
      if (step >= value) {
        state.done[step] = false;
      }
    });
  },
  notificationInstance(state, value) {
    state.notificationInstance = value;
  },
  legalForms(state, value) {
    state.info.legalForms = value;
  },
  legalDocumentsGeneric(state, value) {
    state.info.legalDocuments.generic = value;
  },
  legalDocumentsOperator(state, value) {
    state.info.legalDocuments.operator = value;
  },
  operatorTermsAndConditions(state, value) {
    state.data.operatorTermsAndConditions = value;
  },
  csOperator(state, value) {
    state.info.csOperator = value;
  },
  sectorEntities(state, value) {
    state.info.sectorEntities = value;
  },
  adminCountryCode(state, value) {
    state.data.adminCountryCode = value;
  },
  adminFiscalNumber(state, value) {
    state.data.adminFiscalNumber = value;
  },
  updateStep(state, value) {
    state.currentStep = value;
  },
  companySizes(state, value) {
    state.info.companySizes = value;
  },
  lastStep(state, step) {
    state.lastStep = step;
  },
  // Step 1
  // Company information
  companyName(state, value) {
    state.data.companyName = value;
  },
  country(state, value) {
    state.data.country = value;
  },
  countryCode(state, value) {
    state.data.country_code = value;
  },
  fiscalNumber(state, value) {
    state.data.fiscal_number = value;
  },
  taxNumber(state, value) {
    if (value.length > 2) {
      state.data.taxNumber = value;
    } else {
      state.data.taxNumber = '';
    }
  },
  taxError(state, value) {
    state.data.taxError = value;
  },
  // Work contact information
  workEmail(state, value) {
    state.data.workEmail = value;
  },
  workPhoneNumber(state, value) {
    state.data.workPhoneNumber = value;
  },
  // Admin login
  companyEmail(state, value) {
    state.data.companyEmail = value;
  },
  password(state, value) {
    state.data.password = value;
  },
  title(state, value) {
    state.data.title = value;
  },
  firstName(state, value) {
    state.data.firstName = value;
  },
  lastName(state, value) {
    state.data.lastName = value;
  },
  dateBirth(state, value) {
    const date = moment(value).format('YYYY-MM-DD');
    state.data.datebirth = new Date(date);
  },
  phoneNumber(state, value) {
    state.data.phoneNumber = value;
  },

  // ----
  companyAddress(state, value) {
    if (value && value.address) {
      state.data.companyAddress = value;
    }
  },
  extraCompanyAddress(state, value) {
    state.data.extraCompanyAddress = value;
  },

  legalForm(state, value) {
    state.data.legalForm = value;
  },
  sectorEntity(state, value) {
    state.data.sectorEntity = value;
  },
  companySize(state, value) {
    state.data.companySize = value;
  },
  adminID(state, value) {
    state.data.adminID = value;
  },
  adminIDBase64(state, value) {
    state.data.adminIDBase64 = value;
  },
  incorporationProof(state, value) {
    state.data.incorporationProof = value;
  },
  incorporationProofBase64(state, value) {
    state.data.incorporationProofBase64 = value;
  },
  siretNumber(state, value) {
    state.data.siretNumber = value;
  },
  fiscalCode(state, value) {
    state.data.fiscalCode = value;
  },
  termsAndConditions(state, value) {
    state.data.termsAndConditions = value;
  },
  italyTermsAndConditions(state, value) {
    state.data.italyTermsAndConditions = value;
  },
  countries(state, value) {
    state.info.countries = value;
  },
  titles(state, value) {
    state.info.titles = value;
  },
  extraFields(state, value) {
    state.info.extraFields = value;
  },
  resetCompany(state) {
    return Object.assign(state, getInitialState());
  },
  linkAccountUser(state, value) {
    state.linkAccount.userData = value;
  },
  isLinkAccount(state, value) {
    state.linkAccount.isLinkAccount = value;
  },
  companyCreated(state, value) {
    state.companyCreated = value;
  },
  marketingTerms(state, value) {
    state.data.marketingTerms = value;
  },
  idpUuid(state, value) {
    state.linkAccount.idpUuid = value;
  },
};
export default mutations;
